<template>
  <TemplateUpdateNormal
    :fileUpLoadAction="fileUpLoad.action"
    :fileUpLoadHeaders="fileUpLoad.headers"

    :post="post"
    :prevPost="prevPost"
    :nextPost="nextPost"

    :isAuthor="isAuthor"

    @handleClickUpdate="handleClickUpdate"
    @handleClickCancel="handleClickCancel"
    @handleChangeFile="handleChangeFile"
    @handleSuccessFileUpload="handleSuccessFileUpload"
    @handleDeleteNewFile="handleDeleteNewFile"
    @handleDeleteOldFile="handleDeleteOldFile"
  ></TemplateUpdateNormal>
</template>

<script>
import config from '/public/config'
import TemplateUpdateNormal from '@/views/board/template/update/TemplateUpdateNormal'
import VueCookie from 'vue-cookie'

export default {
  name: 'BoardUpdate',
  components: {
    TemplateUpdateNormal
  },

  computed: {
    isAuthor () {
      if (this.post.author && this.activeUserInfo) {
        const postAuthorId = this.post.author.id
        const userId = this.activeUserInfo.id
        return postAuthorId === userId
      }

      return false
    }
  },

  data () {
    return {
      boardSlug: '',
      boardId: 0,
      postId: 0,
      post: {},
      prevPost: { title:'이전글', postId:0 },
      nextPost: { title:'다음글', postId:0 },

      // 이전글 id, 다음글 id를 구하기 위해서 사용됨
      tableCurrentPage:0, // 현재 페이지 번호
      tablePerPage:0, // 페이지당 노출되는 게시물 개수
      tableSearchKeyword:'', // 검색어
      tablePrevPage:0,
      tableNextPage:0,

      // 파일 업로드 관련 데이터
      fileUpLoad:{
        headers: '',
        action:`${config.BASE_API_URL}/api/v1/file`,
        oldFileIds: [], // 기존에 등록한 파일Id 목록
        files: [] // 등록하고자 하는 파일 목록
      }
    }
  },

  created () {

    this.boardSlug = this.$route.params.boardslug
    this.boardId = 1
    this.postId = this.$route.params.postId

    // notice id 가 없을때 처리
    if (!this.postId) {
      this.$router.back()
      return
    }

    // file upload 시 사용되는 xmlrequest header
    this.fileUpLoad.headers = {
      Authorization: `Bearer ${VueCookie.get('token')}`
    }

    this.loadPostDetail()

  },

  methods: {
    async updatePost (_title, _content) {

      const boardId = this.boardId
      const postId = this.postId
      const title = _title
      const content = _content

      // 첨부파일 처리
      let uploads = ''
      const upload = []

      // 새로 등록한 첨부파일
      if (this.fileUpLoad.files.length > 0) {
        for (const temp of this.fileUpLoad.files) {
          upload.push(temp.uploadedFileId)
        }
      }

      // 기존 등록된 첨부파일 중 삭제되지 않은 첨부파일 ID
      if (this.fileUpLoad.oldFileIds.length > 0) {
        for (const fileId of this.fileUpLoad.oldFileIds) {
          upload.push(fileId)
        }
      }

      uploads = JSON.stringify(upload)

      await this.$store.dispatch('board/UPDATE_POST', {boardId, postId, title, content, uploads})

      this.$router.back()
    },

    async loadPostDetail () {
      // cookie 정보를 가져온다.
      this.loadCookieBoard()

      // 내용불러오기
      const boardId = this.boardId
      const postId = this.postId

      await this.$store.dispatch('board/LOAD_POST', {boardId, postId})
      this.post = this.$store.state.board.postInfo

      // 유저정보
      let userInfo = this.$store.state.auth.userInfo
      if (!userInfo.email || !userInfo.is_activated) {
        const loginResult = await this.$store.dispatch('USER_INFO')
        if (typeof loginResult.error !== 'undefined' && loginResult.error !== null) {
          let msg = this.$constant.ALERT_MSG_UNDEFINED
          msg = `${msg  }\n${  loginResult.error}`
          alert(msg)
        } else {
          userInfo = this.$store.state.auth.userInfo
          this.activeUserInfo = userInfo
        }
      } else {
        this.activeUserInfo = userInfo
      }

      // 첨부파일 가져오기
      for (const file of this.post.post_attachment) {
        this.fileUpLoad.oldFileIds.push(file.id)
      }

    },

    // 쿠키에 저장된 데이터를 불러온다.
    loadCookieBoard () {
      this.tableCurrentPage = VueCookie.get('table_current_page')
      this.tablePerPage = VueCookie.get('table_per_page')
      this.tableSearchKeyword = VueCookie.get('table_search_keyword')
    },

    handleClickUpdate (_title, _content) {
      this.updatePost(_title, _content)
    },
    handleClickCancel () {
      this.$router.back()
    },

    handleChangeFile (path, files) {
      this.fileUpLoad.files = files
    },
    handleSuccessFileUpload (uploadedFileID) {
      const file = this.fileUpLoad.files[this.fileUpLoad.files.length - 1]
      file.uploadedFileId = uploadedFileID
    },
    handleDeleteNewFile (file) {
      // 새로 등록한 파일중에 삭제
      this.fileUpLoad.files.remove(file)
    },
    handleDeleteOldFile (fileId) {
      // 기존 등록된 파일중에 삭제
      this.fileUpLoad.oldFileIds.remove(fileId)

    }
  }
}
</script>

<style scoped>

</style>
